module.exports = __webpack_public_path__ + "static/media/Cross-platform.93b87a8e.svg";